import React from 'react';
import { Outlet } from 'react-router-dom';
import GlobalTradingNav from './GlobalTradingNav';
import GlobalSoldTodayBar from './GlobalSoldTodayBar';
import MobileBottomNav from './MobileBottomNav';
import './GlobalTradingNav.css';
import './mobile-app.css';

export default function AppShell() {
  return (
    <div className="app-shell">
      <GlobalTradingNav />
      <GlobalSoldTodayBar />
      <div className="app-shell-content">
        <Outlet />
      </div>
      <MobileBottomNav />
    </div>
  );
}
